import { Card } from '@mui/material';
import { useTranslate } from 'react-admin';
import { CustomBreadcrumbs } from 'src/components/custom-breadcrumbs';
import { DashboardContent } from 'src/layouts/dashboard';
import ErrorPage403 from 'src/pages/error/403';
import { PermissionGuard } from 'src/routes/components';
import { Resources } from '../resource';
import UserRetentionChart from '../user-info/UserRetentionChart';

const TradingRetentionList = () => {
  const t = useTranslate();

  return (
    <PermissionGuard resource="trading-retention" action="read" fallback={<ErrorPage403 />}>
      <DashboardContent>
        <CustomBreadcrumbs
          heading={t('resource.tradingRetention')}
          links={[{ name: t('resource.tradingRetention'), href: `/${Resources.tradingRetention}` }]}
        />
        <Card sx={{ mt: 2 }}>
          <UserRetentionChart />
        </Card>
      </DashboardContent>
    </PermissionGuard>
  );
};

export default TradingRetentionList;
